import { Component, OnInit } from '@angular/core';
import { PerfilEstrutura } from 'src/app/models/perfil-estrutura';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PerfilEstruturaService } from 'src/app/services/perfil-estrutura.service';
import { MatDialog } from '@angular/material';
import { GlobalService } from 'src/app/services/global.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { MaxPainelModalComponent } from 'src/app/modals/max-painel-modal/max-painel-modal.component';
import { MaxPainelService } from 'src/app/services/max-painel.service';

declare const $: any;

@Component({
  selector: 'app-cadastrar-perfil-estrutura',
  templateUrl: './cadastrar-perfil-estrutura.component.html',
  styleUrls: ['./cadastrar-perfil-estrutura.component.scss']
})
export class CadastrarPerfilEstruturaComponent implements OnInit {
  idPerfil: number;
  perfil = new PerfilEstrutura();

  maxPerfis = [];

  orientacoes = [
    {
      id: 0,
      descricao: "Retrato"
    },
    {
      id: 1,
      descricao: "Paisagem"
    }
  ];

  constructor(
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private perfilEstruturaService: PerfilEstruturaService,
    public dialog: MatDialog,
    private router: Router,
    private globalService: GlobalService,
    private carregandoService: CarregandoService,
    private utilitarioService: UtilitarioService,
    private maxPainelService: MaxPainelService
  ) {
  }

  ngOnInit() {
    if (this.route.snapshot.paramMap.get('id')) {
      this.idPerfil = Number(this.route.snapshot.paramMap.get('id'));
      this.buscarPerfil();
    } else {
      this.perfil = new PerfilEstrutura();
    }

    this.buscarMaxPainel();
  }

  ngAfterViewInit(): void {
    this.utilitarioService.rodaScriptTabEnter();
  }

  buscarPerfil() {
    this.carregandoService.mostra('buscaPerfil');

    this.perfilEstruturaService.consultarPerfilEstrutura(this.idPerfil).subscribe(perfil => {
      this.perfil = perfil;
      this.carregandoService.esconde('buscarPerfil')
    }, (erro) => {
      this.carregandoService.esconde('buscaPerfil');
      this.notificacaoService.erro(erro);
    });
  }

  buscarMaxPainel() {
    this.carregandoService.mostra('buscarMaxPerfis');

    this.maxPainelService.consultarLista().subscribe(
      maxperfis => {
        this.maxPerfis = maxperfis;
        this.carregandoService.esconde('buscarMaxPerfis');
      },
      err => {
        this.carregandoService.esconde('buscarMaxPerfis');

        this.notificacaoService.erro(err);
      }
    )
  }

  abrirModalMaxPainel() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(MaxPainelModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((res) => {
      this.buscarMaxPainel();
    });
  }

  salvar() {
    this.perfil.larguraModulo = Number(this.perfil.larguraModulo);
    this.perfil.tamPerfil = Number(this.perfil.tamPerfil);

    this.carregandoService.mostra('salvar');

    this.perfilEstruturaService.salvar(this.perfil).subscribe(() => {
      this.notificacaoService.sucesso('Perfil salvo com sucesso!!!');
      this.router.navigate(['/configuracoes/perfil-estrutura']).then(() => {
        this.carregandoService.esconde('salvar');
      });
    }, (erro) => {
      this.carregandoService.esconde('salvar');
      this.notificacaoService.erro(erro);
    });
  }

  ngOnDestroy(): void {

  }

  voltar() {
   this.router.navigate(['/configuracoes/perfil-estrutura']);
  }

}
